export const roles = {
  ADMIN: process.env.REACT_APP_ROLE_ADMIN || 'admin',
  MANAGER: process.env.REACT_APP_ROLE_MANAGER || 'MANAGER',
  EMPLOYEE: process.env.REACT_APP_ROLE_EMPLOYEE || 'employee',
  HR: process.env.REACT_APP_ROLE_HR || 'hr',
};

export const getRole = (backendRole) => {
  const normalizedRole = backendRole?.toLowerCase();
  switch (normalizedRole) {
    case process.env.REACT_APP_ROLE_HR:
      return 'HR';
    case process.env.REACT_APP_ROLE_ADMIN:
      return 'ADMIN';
    case process.env.REACT_APP_ROLE_MANAGER:
      return 'MANAGER';
    case process.env.REACT_APP_ROLE_EMPLOYEE:
      return 'EMPLOYEE';
    default:
      return null; // or throw an error
  }
};